import yup from '../../../../config/yup/customYup';

export default yup
  .object({
    subsidiaries: yup.object().required(),
  })
  .required();
